import './lib/firebase'
import './lib/vue/filters'

import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import App from './App.vue'
import setup from './setup'
import ConvrrtCheckoutComponents from '../../storybook/components/checkout'
import ConvrrtMaterialDesignComponents from '../../storybook/components/material'
import { SweetModal } from 'sweet-modal-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas)

Vue.config.productionTip = false

Sentry.init({
  dsn: 'https://5c8f627a2d7b47619c33b932386eeae5@sentry.io/1526047',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })]
})

Vue.use(ConvrrtCheckoutComponents)
Vue.use(ConvrrtMaterialDesignComponents)
Vue.component('sweet-modal', SweetModal)
Vue.component('font-awesome-icon', FontAwesomeIcon)

const { router, store } = setup()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
